export const MRN_MAX_LENGTH = 50;
export const FORM_TYPE_RESEARCH = 'research';
